import * as Period from '../../../../constants/Period';
var BEACH_VOLLEYBALL_PERIOD_MAP = {};
BEACH_VOLLEYBALL_PERIOD_MAP[300] = Period.NOT_STARTED;
BEACH_VOLLEYBALL_PERIOD_MAP[301] = Period.FIRST;
BEACH_VOLLEYBALL_PERIOD_MAP[302] = Period.SECOND;
BEACH_VOLLEYBALL_PERIOD_MAP[303] = Period.THIRD;
BEACH_VOLLEYBALL_PERIOD_MAP[304] = Period.FINISHED;
export default BEACH_VOLLEYBALL_PERIOD_MAP;



// WEBPACK FOOTER //
// ./src/components/grid/sportGlossary/BeachVolleyball/PeriodMap.js